export const CODE_NEW_SESSION_COMPOSER = 'new-session';
export const CODE_FOLLOW_UP_COMPOSER = 'follow-up';

export function focusNewSessionComposer() {
  document
    .querySelector<HTMLTextAreaElement>(`textarea[data-composer="${CODE_NEW_SESSION_COMPOSER}"]`)
    ?.focus();
}
